import { REGISTERED_EMAIL } from "../actions/onboarding.action"
import { OnboardingReducer } from "../models/onboarding.interface"

const initialState: OnboardingReducer = {
    email: ""
}

const onboardingReducer = (state: OnboardingReducer = initialState, action: any): OnboardingReducer => {
    switch (action.type) {

        case REGISTERED_EMAIL:
            return {
                ...state,
                email: action.email
            }

        default:
            return state;
    }
}

export default onboardingReducer;